export const BACKGROUND_COLORS = {
  WHITE: '#ffffff',
  GREY_200: '#EEEEEE',
  OFF_WHITE: '#f8fafc',
  TEST_CUSTOM: '#f5f5f5'
} as const;

export const TEXT_COLORS = {
  TEXT_PRIMARY: 'rgba(0, 0, 0, 0.87)',
  NEAR_BLACK: '#1a1a1a',
  GREY_600: '#757575',
  BLACK: '#000000',
  PRIMARY_ACCENT_FALLBACK: '#111111',
  MUTED: '#64748b',
  /** Table-header text on `BORDER_COLORS.FAINT`. About 6.9:1, so 10px bold clears WCAG AA. */
  ON_FAINT: '#475569',
  TEST_CUSTOM: '#336699'
} as const;

export const BORDER_COLORS = {
  DEFAULT: '#E3E8EF',
  /** UI boundary (field underlines); ≥3:1 on white for WCAG 1.4.11. */
  MUTED: '#858585',
  FAINT: '#f1f5f9',
  LIGHT: '#e2e8f0',
  DASHED: '#cbd5e1'
} as const;

export const ACCENT_COLORS = {
  DEFAULT: '#1976d2',
  DEEP_BLUE: '#0369a1',
  PRIMARY_DARK: '#115293',
  TEST_INPUT: '#123456',
  TEST_SAMPLE: '#0055aa',
  TEST_GREEN: '#009900',
  TEST_VARIANT: '#aabbcc',
  TEST_ERROR: '#ff0000'
} as const;

export const RGBA_COLORS = {
  REPEATABLE_HEADER_BG: 'rgba(0, 0, 0, 0.03)',
  COMPOSITION_INVISIBLE_BG: 'rgba(0,0,0,0.02)',
  COMPOSITION_BORDER: 'rgba(0,0,0,0.12)',
  COMPOSITION_DRAG_ACTIVE_BORDER: 'rgba(25,118,210,0.8)',
  /** Soft paper elevation for multi-page preview sheets. */
  PAGE_PAPER_SHADOW: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.08)'
} as const;
